/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Abbreviated match result for score submission and confirmation responses
 * @export
 * @interface MatchResultSummary
 */
export interface MatchResultSummary {
    /**
     * 
     * @type {string}
     * @memberof MatchResultSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchResultSummary
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchResultSummary
     */
    team1Score?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchResultSummary
     */
    team2Score?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchResultSummary
     */
    winnerId?: string;
}

/**
 * Check if a given object implements the MatchResultSummary interface.
 */
export function instanceOfMatchResultSummary(value: object): value is MatchResultSummary {
    return true;
}

export function MatchResultSummaryFromJSON(json: any): MatchResultSummary {
    return MatchResultSummaryFromJSONTyped(json, false);
}

export function MatchResultSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchResultSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
    };
}

export function MatchResultSummaryToJSON(json: any): MatchResultSummary {
    return MatchResultSummaryToJSONTyped(json, false);
}

export function MatchResultSummaryToJSONTyped(value?: MatchResultSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'winnerId': value['winnerId'],
    };
}

